<script setup lang="tsx">
import { reactive, ref } from "vue";
import Page from "../base/Page.vue";
import List from "../base/List.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Page, List },
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{}>();

let items = reactive(Array.from({ length: 20 }, (_, i) => i + 1));

let isRefreshing = ref(false);
let isLoading = ref(false);
let isNoMore = ref(false);
async function refreshing() {
  console.log("refreshing");
  isRefreshing.value = true;
  // 模拟网络请求
  await new Promise((resolve) => setTimeout(resolve, 2000));
  // 刷新完成后
  items = Array.from({ length: 20 }, (_, i) => i + 1); // 假设重新加载数据
  isRefreshing.value = false;
  isNoMore.value = false;
}

let index = 0;
async function loading() {
  console.log("loading");
  isLoading.value = true;
  // 模拟网络请求
  await new Promise((resolve) => setTimeout(resolve, 2000));
  // 加载更多数据
  items.push(...Array.from({ length: 10 }, (_, i) => i + items.length + 1));
  isLoading.value = false;
  isNoMore.value = ++index >= 2;
}

defineExpose({});
</script>

<template>
  <Page class="list">
    <List
      :isRefreshing="isRefreshing"
      :isLoading="isLoading"
      :isNoMore="isNoMore"
      @refreshing="refreshing"
      @loading="loading"
    >
      <div
        v-for="i in items"
        :key="i"
        class="item"
      >
        Item {{ i }}
      </div>
    </List>
  </Page>
</template>

<style scoped>
.item {
  padding: 15px 0;
  margin-bottom: 2px;
  background-color: pink;
}
</style>
